import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";

function PersonalProveedores() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    
    // Permisos específicos para cada sección
    const [tienePermisoGeneral, setTienePermisoGeneral] = useState(false);
    const [tienePermisoPersonal, setTienePermisoPersonal] = useState(false);
    let userdata = [];
    let clientData = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS
        const tienePermisoGeneralModulo = userdata.up && userdata.up.includes('administrarPersonalProveedores');
        const tienePermisoGestionPersonal = userdata.up && userdata.up.includes('gestionPersonal');
        
        // Debe tener al menos uno de los dos permisos para acceder al módulo
        if (!tienePermisoGeneralModulo && !tienePermisoGestionPersonal) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);
        setTienePermisoGeneral(tienePermisoGeneralModulo);
        setTienePermisoPersonal(tienePermisoGestionPersonal);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        axios.get('/get-client?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
            });
    },[]);

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item">Administrador de Personal y Proveedores</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Administrador de Personal y Proveedores</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            
                            <div className="row">
                                <div className="col-md-12 btn-settings-container">
                                    
                                    {/* Personal y Profesionales - Requiere permiso específico */}
                                    {tienePermisoPersonal && (
                                        <Link to="/personal" className="btn-settings">
                                        Personal y Profesionales
                                        </Link>
                                    )}

                                    {/* Proveedores - Requiere permiso general */}
                                    {tienePermisoGeneral && (
                                        <Link to="/proveedores" className="btn-settings">
                                        Proveedores
                                        </Link>
                                    )}

                                    {/* Usuario SISPRO - Requiere permiso general */}
                                    {tienePermisoGeneral && (
                                        <Link to="/usuarios-sispro" className="btn-settings">
                                        Usuarios SISPRO
                                        </Link>
                                    )}

                                    {/* ℹ️ NOTA: Especialidades, Cargos y Tipos de Contrato ahora se gestionan desde el Panel Superadmin */}

                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default PersonalProveedores;